import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { DEPRECATED_Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { useState } from "react";
import classnames from "classnames/bind";

import styles from "./SupplierServices.module.scss";

const cx = classnames.bind(styles);

const openingHours = [
  ["Monday to Friday", "8am - 9pm"],
  ["Saturday", "8am - 8pm"],
  ["Sunday", "10am - 6pm"],
];

type SupplierServicesUIProps = {
  isNewTypographyEnabled: boolean;
};

export const SupplierServicesUI = ({
  isNewTypographyEnabled,
}: SupplierServicesUIProps) => {
  const [isOpen, toggleOpen] = useState(false);

  return (
    <div>
      <DEPRECATED_Message
        title={" "}
        body={
          <div>
            <p
              data-testid="supplierServicesMessage"
              data-cy="supplier-direct-message"
              className={cx("SupplierServices__container", {
                newTypography: isNewTypographyEnabled,
              })}
            >
              If you need installation or recycling services with this product,
              please do not order online. Call our Customer Services Team on{" "}
              <a
                href="tel:03456048835"
                className={styles.SupplierServices__phoneNumber}
              >
                0345 604 8835
              </a>{" "}
              and we&apos;ll place your order for you.
            </p>
            <UnderlinedButton
              onClick={() => toggleOpen(true)}
              labelText="View contact centre opening hours"
            />
          </div>
        }
        type={"information"}
        containerProps={{ ["data-component"]: "SupplierServices" }}
      />
      <Modal
        isOpen={isOpen}
        onClose={() => toggleOpen(false)}
        title="Contact centre opening hours"
        footer={false}
        height="hug"
        width="medium"
      >
        {openingHours.map(([days, times]) => (
          <div className={styles.SupplierServices__row} key={days}>
            <div className={styles.SupplierServices__days}>{days}</div>
            <div className={styles.SupplierServices__times}>{times}</div>
          </div>
        ))}
      </Modal>
    </div>
  );
};
